import { render, staticRenderFns } from "./attendance_group_change.vue?vue&type=template&id=551089f0&"
import script from "./attendance_group_change.vue?vue&type=script&lang=js&"
export * from "./attendance_group_change.vue?vue&type=script&lang=js&"
import style0 from "./attendance_group_change.vue?vue&type=style&index=0&id=551089f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports